module.exports = __webpack_public_path__ + "img/logout.5cee32f4.svg";